<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg
      v-if="exceptionMsg"
      :msg="exceptionMsg"
      :image="exceptionImg"
    />

    <PlacesWorkPlanForm
      v-if="!isLoading && !isCatch"
      :placesWorkPlanData="placesWorkPlanData"
      :submitName="$t('edit')"
      v-on:addOrUpdatePlacesWorkPlan="updatePlacesWorkPlan"
    />
  </div>
</template>

<script>
import createToastMixin from "@/utils/create-toast-mixin";
import { STATUS } from "@/utils/constants";
import PlacesWorkPlan from "@/models/places/placesWorkPlans/PlacesWorkPlan";
import PlacesWorkPlanForm from "@/components/places/placesWorkPlans/PlacesWorkPlanForm.vue";
export default {
  name: "PlacesWorkPlanEdit",
  mixins: [createToastMixin],
  components: {
    PlacesWorkPlanForm,
  },
  data() {
    return {
      placesWorkPlanData: new PlacesWorkPlan(),
      placeWorkPlanToken: this.$route.params.placeWorkPlanToken,
    };
  },
  methods: {
    async getPlacesWorkPlanDetails() {
      this.isLoading = true;
      this.placesWorkPlanData.placeWorkPlanToken = this.placeWorkPlanToken;
      try {
        let response = await this.placesWorkPlanData.getPlacesWorkPlansDetails(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.placesWorkPlanData.fillData(response.data.placeWorkPlanData);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.placesWorkPlanData = null;
        }
      } catch (error) {
        console.log(error);
        this.placesWorkPlanData = null;
        this.exceptionMsg = this.$t("errorCatch");
        this.exceptionImg = "noInternet.svg";
      }
      this.isLoading = false;
    },
    async updatePlacesWorkPlan() {
      this.isLoading = true;
      try {
        let response = await this.placesWorkPlanData.addOrUpdatePlacesWorkPlan(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push({ name: "PlacesWorkPlans" });
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.errorCatch();
      }
      this.isLoading = false;
    },
  },
  computed: {},
  async created() {
    this.getPlacesWorkPlanDetails();
  },
};
</script>

<style scoped lang="scss"></style>
